import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PromotionDetailComponent} from './promotion-detail.component';
import {PromotionDetailRoutingModule} from './promotion-detail-routing.module';
import {PromotionDetailDesktopComponent} from './promotion-detail-desktop/promotion-detail-desktop.component';
import {PromotionDetailMobileComponent} from './promotion-detail-mobile/promotion-detail-mobile.component';
import {FavButtonModule} from '@app/presentation/components/fav-button/fav-button.module';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {AppBarModule} from '@app/presentation/components/app-bar/app-bar.module';
import {ProductCarouselModule} from '@app/presentation/components/product-carousel/product-carousel.module';
import {TranslateModule} from '@ngx-translate/core';
import {LocalizedCurrencyModule} from '@app/presentation/pipes/localized-currency/localized-currency.module';
import {BreadcrumbModule} from '@app/presentation/components/breadcrumb/breadcrumb.module';
import {
    PromotionDetailProductTileComponent
} from './promotion-detail-product-tile/promotion-detail-product-tile.component';
import {
    AddPromotionToCartButtonModule
} from '@app/presentation/components/add-promotion-to-cart-button/add-promotion-to-cart-button.module';
import {SimilarProductsModule} from '@app/presentation/components/similar-products/similar-products.module';
import {NgxSkeletonLoaderModule} from "ngx-skeleton-loader";
import {LocalizeRouterModule} from "@gilsdav/ngx-translate-router";
import {LabelComponent} from '@app/presentation/components/label/label.component';


@NgModule({
    declarations: [
        PromotionDetailComponent,
        PromotionDetailDesktopComponent,
        PromotionDetailMobileComponent,
        PromotionDetailProductTileComponent
    ],
    exports: [
        PromotionDetailProductTileComponent
    ],
    imports: [
        CommonModule,
        PromotionDetailRoutingModule,
        FavButtonModule,
        AngularSvgIconModule,
        AppBarModule,
        ProductCarouselModule,
        TranslateModule,
        LocalizedCurrencyModule,
        BreadcrumbModule,
        AddPromotionToCartButtonModule,
        SimilarProductsModule,
        NgxSkeletonLoaderModule,
        LocalizeRouterModule,
        LabelComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PromotionDetailModule { }
